import React from "react";
import "./Ourphoto.css";
import Marquee from "react-fast-marquee";

const Ourphoto = () => {
  return (
    <div className="container" id="stories">
      <Marquee speed={50} pauseOnClick>
        <div className="container-slider">
          <img
            src={require("../../../assets/images/team_photo-1.jpg")}
            alt="no photo"
          />
          <img
            src={require("../../../assets/images/team_photo-3.jpg")}
            alt="no photo"
          />
          <img
            src={require("../../../assets/images/team_photo-2.jpg")}
            alt="no photo"
          />
        </div>
        ;
      </Marquee>
    </div>
  );
};

export default Ourphoto;
